import type { BidWorkOrderFile } from '../detailApi';

type Props = {
  files: BidWorkOrderFile[];
  thumb?: 'thumb_200_200' | 'thumb_120_120';
};

/** Simple file strip: images open in a new tab, PDFs as document links. */
export const FileGallery = ({ files, thumb = 'thumb_200_200' }: Props) => {
  if (!files.length) return <p className="text-muted">Нет файлов</p>;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {files.map((file) => {
        const isPdf = file.mime_type === 'application/pdf';
        const src = file[thumb] || file.url;
        if (isPdf) {
          return (
            <a key={file.id} href={file.url} target="_blank" rel="noopener noreferrer" className="btn btn-default btn-sm">
              PDF{file.name ? `: ${file.name}` : ''}
            </a>
          );
        }
        return (
          <a key={file.id} href={file.url || src} target="_blank" rel="noopener noreferrer">
            <img src={src || file.url} alt={file.name ?? ''} style={{ height: 100, objectFit: 'cover' }} />
          </a>
        );
      })}
    </div>
  );
};
